import { Pill, Text } from "@instructure/ui";
import { t } from "i18next";
import { useContext, useEffect, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";

import DataGrid from "react-data-grid";
import { MasteryLevelContext } from "../../../../utils/Context";
import { TruncateToolTip } from "../../../../utils/TruncateTooltip";

const RatingScalePreview = ({ ratingScaleId }) => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const { ratingScales, masteryLevels } = useContext(MasteryLevelContext);

  useEffect(() => {
    const ratingScale = ratingScales.find((r) => r.id === ratingScaleId);
    if (ratingScale) {
      const cols = [];
      const row = [];
      ratingScale.levels.forEach((level, num) => {
        const masteryLevelId = level.mastery_level_id;
        const key = masteryLevelId + "-" + num;
        const selectedLevel = masteryLevels.find(
          (masteryLevel) => masteryLevel.id === masteryLevelId
        );
        cols.push({
          key,
          name: selectedLevel ? (
            <Text size="small">
              {selectedLevel.level}
              {parseInt(level.points) ===
                parseInt(ratingScale.mastery_points) && (
                <Pill color="success" margin="x-small">
                  {t("masteryLevels.mastery")}
                </Pill>
              )}
            </Text>
          ) : (
            <Text fontStyle="italic" size="small">
              {t("masteryLevels.notAssigned")}
            </Text>
          ),
        });
        row[key] = (
          <TruncateToolTip
            maxLines={5}
            renderTip={
              <div style={{ maxWidth: 250 }}>
                <Text wrap="wrap">{level.description}</Text>
              </div>
            }
          >
            <Text size="small" wrap="wrap">
              {level.points} - {level.description}
            </Text>
          </TruncateToolTip>
        );
      });
      setColumns(cols);
      setRows(row);
    }
  }, [ratingScaleId, masteryLevels, ratingScales]);

  return (
    <DataGrid
      columns={columns}
      rows={[rows]}
      style={{ height: "auto", maxHeight: "250px", marginTop: "10px" }}
      rowKeyGetter={(row) => row.id}
      headerRowHeight={40}
      rowHeight={120}
      className="rdg-light"
    />
  );
};

export default RatingScalePreview;
